import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import ExamStudioPage from '../../features/studio-exams/components/ExamStudioPage';

const ExamStudioRoute = () => {
  return (
    <ProtectedRoute requiresAuth>
      <ExamStudioPage />
    </ProtectedRoute>
  );
};

export default ExamStudioRoute;
